import React from 'react';
import { Box } from '@mui/material';

interface MainListModuleProps {
  leftSidebar: React.ReactNode;
  toolbar: React.ReactNode;
  dataTable: React.ReactNode;
  children?: React.ReactNode;
  /** When true, data area scrolls instead of clipping tall report tables */
  dataTableScrollable?: boolean;
  /** When true, content grows with the page and uses browser scroll (no inner scroll container) */
  browserScroll?: boolean;
}

export default function MainListModule({
  leftSidebar,
  toolbar,
  dataTable,
  children,
  dataTableScrollable = false,
  browserScroll = false,
}: MainListModuleProps) {
  const useViewportFill = !browserScroll;

  return (
    <Box
      sx={{
        display: 'flex',
        height: useViewportFill ? '100%' : 'auto',
        width: '100%',
        mt: 0,
        overflow: useViewportFill ? 'hidden' : 'visible',
      }}
    >
      {leftSidebar && (
        <Box
          sx={{
            width: 250,
            flexShrink: 0,
            borderRight: '1px solid #e5e7eb',
            backgroundColor: '#f9fafb',
            overflowY: 'auto',
            pt: 0,
            pb: 2,
          }}
        >
          {leftSidebar}
        </Box>
      )}

      <Box
        sx={{
          flex: useViewportFill ? 1 : 'none',
          display: 'flex',
          flexDirection: 'column',
          p: 2,
          pt: 0,
          overflow: useViewportFill ? 'hidden' : 'visible',
        }}
      >
        {toolbar}
        <Box
          sx={{
            flex: useViewportFill ? 1 : 'none',
            minHeight: useViewportFill ? 0 : 'auto',
            mt: 0,
            overflow: browserScroll
              ? 'visible'
              : dataTableScrollable
                ? 'auto'
                : 'hidden',
          }}
        >
          {dataTable}
        </Box>
      </Box>

      {/* Custom Children */}
      {children}
    </Box>
  );
}
